import React, {useState, useEffect, useContext} from "react";
import {Button, Typography} from "@material-ui/core";
import {useHistory} from "react-router-dom";
import {AppContext} from "../AppContext";
import {MessageContext} from "../MessageContext";
import useFormState from "./useFormState";
import moment from "moment";
import CreatEventFromEventBrite from "./admin/CreatEventFromEventBrite";

export default function AdminHome(props) {
    const history = useHistory();
    const [futureEvents, setFutureEvents] = useState([])
    const [pastEvents, setPastEvents] = useState([])
    const [ebReady, setEbReady] = useState(false)
    const [ebToken, setEbToken] = useState(null)
    const [eventBriteEventId, setEventBriteEventId] = useFormState("")

    const context = useContext(AppContext)
    const messageContext = useContext(MessageContext)

    const sendEBToken = (token) => {
        fetch(`${process.env.REACT_APP_API_CALL}/user-eventbrite-token`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                eventbrite_token: token
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    console.log("---------BEFORE------------")
                    alert(response.errors)
                    console.log("---------AFTER------------")
                } else {
                    setEbToken(token)
                    history.push("/admin_home")

                    let savedToken = token ? "Event registration successful!" : "Logged out of EventBrite";
                    messageContext.showSuccessMessage(savedToken)
                }
            })
    }

    useEffect(() => {
        const tokenIndex = document.URL.lastIndexOf("access_token=")
        if (tokenIndex > 0) {
            // const params = new URLSearchParams(document.URL.substring(tokenIndex));
            // console.log("params", params)
            let token = document.URL.substring(tokenIndex + "access_token=".length)
            if (token) {
                console.log("token", token)
                sendEBToken(token)
            }
        }
    }, [])

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/get-future-events`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(response => setFutureEvents(response))

    }, [])

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/get-past-events`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(response => setPastEvents(response))

    }, [])

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/user-eventbrite-token`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(response => {
                    setEbReady(true)
                    console.log("response.eventbrite_token", response.eventbrite_token)
                    setEbToken(response.eventbrite_token)
                }
            )
    }, [])

    const creatFromEventBrite = (ebId) => {
        fetch(`https://www.eventbriteapi.com/v3/events/${ebId}/`, {
            headers: new Headers({
                'Authorization': 'Bearer ' + ebToken
            })
        })
            .then(response => response.json())
            .then(response => {
                    console.log("response", response)
                console.log("name.text", response.name.text)
                console.log("description.text", response.description.text)
                const startDate = moment(response.start.local).toDate()
                const endDate = moment(response.end.local).toDate()

                console.log("startDate", startDate)
                console.log("endDate", endDate)

                fetch(`${process.env.REACT_APP_API_CALL}/events`, {
                    method: "POST",
                    credentials: 'include',
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json"
                    },
                    body: JSON.stringify({
                        name: response.name.text,
                        description: response.description.text,
                        host_user: context.currentUser.id,
                        price: 0,
                        start_time: startDate,
                        finish_time: endDate,
                        timezone: "EST",
                        venue: "MainVenue",
                        venueData: "{}",
                        eventbrite_id: ebId
                    })
                })
                    .then(response => response.json())
                    .then(response => {
                        if (response.errors) {
                            messageContext.showErrorMessage(response.errors)
                        } else {
                            messageContext.showSuccessMessage("Event has been created")

                            history.push(`/admin/event/${response.id}`)
                        }
                    })
                }
            )
    }

    const redirectToEvent = (event) => {
        history.push(`/admin/event/${event.id}`)
    }

    const authEventBrite = () => {
        //`${process.env.REACT_APP_EVENTBRITE_REDIRECT_URI}`
        const redirectUrl = encodeURIComponent(document.URL)
        const callUrl = `https://www.eventbrite.com/oauth/authorize?response_type=token&client_id=${process.env.REACT_APP_EVENTBRITE_CLIENT_ID}&redirect_uri=${redirectUrl}`
        document.location = callUrl
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        creatFromEventBrite(eventBriteEventId)
    }

    const eventbriteBody = () => <><Typography variant='h2'>EventBrite</Typography>

        {ebToken ?
            <><Button
                variant="contained"
                color="secondary"
                size="large"
                onClick={() => sendEBToken(null)}
            >
                Log Out
            </Button>

                <CreatEventFromEventBrite/>
            </>
            :
            <>
                EventBit uses EventBrite to manage event data and attendees. Log into your EventBrite account and
                give our app access to query your data.
                <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    onClick={authEventBrite}
                >
                    Authenticate
                </Button>

            </>
        }
    </>

    return (
        <div className="manage-events-body">
            {ebReady && eventbriteBody()}

            <Typography variant='h2'>Manage Events</Typography>

            <Typography variant='h4'>Future Events</Typography>
            <ul>
                {futureEvents.map((event) => <li key={event.id}>{event.name} <Button
                    onClick={() => redirectToEvent(event)}>Edit</Button></li>)}
            </ul>

            <Typography variant='h4'>Past Events</Typography>
            <ul>
                {pastEvents.map((event) => <li key={event.id}>{event.name}</li>)}
            </ul>
        </div>
    )
}
